import React from 'react';

import Support from '@src/components/Support';
import useProfile from '@src/hooks/useProfile';

import { Props } from './props';

const goftinoUrl = 'https://goftino.com/c/20S8eL';
const goftinoId = '20S8eL';
const goftinoWidgetUrl = 'https://www.goftino.com/widget/';

const Screen: React.FC<Props> = () => {
  const user = useProfile();

  return (
    <Support
      user={user}
      src={goftinoWidgetUrl}
      supportId={goftinoId}
      url={goftinoUrl}
      async
      onLoad={() => {}}
    />
  );
};

export default Screen;
